const server_address = 'https://bckhan-pay-data.s3-ap-southeast-1.amazonaws.com';
const flag_image_path = 'flag_images/48'; // +'/<country_code>.png'

export default {
  server_address,
  flag_image_path
}